module.exports = __webpack_public_path__ + "img/17.e38ab8b0.jpg";